import { render, staticRenderFns } from "./FormulateLabel.vue?vue&type=template&id=23c9a91f&"
import script from "./FormulateLabel.vue?vue&type=script&lang=js&"
export * from "./FormulateLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23c9a91f')) {
      api.createRecord('23c9a91f', component.options)
    } else {
      api.reload('23c9a91f', component.options)
    }
    module.hot.accept("./FormulateLabel.vue?vue&type=template&id=23c9a91f&", function () {
      api.rerender('23c9a91f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/formulate/label/FormulateLabel.vue"
export default component.exports